import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle<{ color: any }>`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: 'Jost', Arial, sans-serif;
  }
  h1, h2, h3, h4, h5, h6 {
    line-height: 1.4;
    font-weight: 500;
  }
  a {
    text-decoration: none;
  }
  body {
    ${(props) => `background: ${props.color};`}
  }
  svg {
    fill: currentColor;
  }
  
`;

export default GlobalStyle;
